module.exports = __webpack_public_path__ + "img/red-2-diamond-open.02b11afd.svg";